// 日本語辞書 (キーの正。en.ts はこのキー集合に合わせる)
export const ja = {
  'app.name': 'Browser Photo Editor',
  'app.untitled': '名称未設定',
  'menu.file': 'ファイル',
  'menu.file.new': '新規...',
  'menu.file.open': '開く...',
  'menu.file.save': 'プロジェクトを保存 (ZIP)...',
  'menu.file.export': '画像を書き出し...',
  'menu.file.close': '閉じる',
  'menu.edit': '編集',
  'menu.edit.undo': '取り消し',
  'menu.edit.redo': 'やり直し',
  'menu.layer': 'レイヤー',
  'menu.layer.new': '新規レイヤー',
  'menu.layer.delete': 'レイヤーを削除',
  'menu.layer.duplicate': 'レイヤーを複製',
  'menu.view': '表示',
  'menu.view.zoomIn': 'ズームイン',
  'menu.view.zoomOut': 'ズームアウト',
  'menu.view.actual': '100% 表示',
  'menu.view.fit': '画面サイズに合わせる',
  'menu.view.theme': 'テーマ切替',
  'menu.view.language': 'English',
  'menu.help': 'ヘルプ',
  'menu.help.about': 'このアプリについて',
  'menu.help.shortcuts': 'ショートカット一覧',
  'tool.move': '移動ツール',
  'tool.hand': '手のひらツール',
  'tool.zoom': 'ズームツール',
  'tool.marquee': '長方形選択ツール',
  'tool.lasso': 'なげなわツール',
  'tool.wand': '自動選択ツール',
  'menu.image': 'イメージ',
  'menu.image.size': '画像解像度...',
  'menu.image.canvasSize': 'カンバスサイズ...',
  'menu.image.rotate90': '90° (時計回り)',
  'menu.image.rotate270': '90° (反時計回り)',
  'menu.image.rotate180': '180°',
  'menu.image.flipH': 'カンバスを左右に反転',
  'menu.image.flipV': 'カンバスを上下に反転',
  'menu.layer.flipH': 'レイヤーを左右に反転',
  'menu.layer.flipV': 'レイヤーを上下に反転',
  'menu.layer.rotate90': 'レイヤーを 90° 回転 (時計回り)',
  'menu.layer.rotate270': 'レイヤーを 90° 回転 (反時計回り)',
  'menu.layer.rotate180': 'レイヤーを 180° 回転',
  'menu.edit.freeTransform': '自由変形',
  'history.crop': '切り抜き',
  'history.canvasSize': 'カンバスサイズ',
  'history.imageSize': '画像解像度',
  'history.rotateCanvas': 'カンバスの回転',
  'history.flipCanvas': 'カンバスの反転',
  'history.transformLayer': 'レイヤーの変形',
  'history.freeTransform': '自由変形',
  'dialog.canvas.title': 'カンバスサイズ',
  'dialog.canvas.anchor': '基準位置',
  'dialog.canvas.current': '現在のサイズ',
  'dialog.image.title': '画像解像度',
  'dialog.image.keepRatio': '縦横比を固定',
  'dialog.image.method': '再サンプル',
  'dialog.image.nearest': 'ニアレストネイバー',
  'dialog.image.bilinear': 'バイリニア',
  'dialog.image.bicubic': 'バイキュービック',
  'transform.commit': '確定 (Enter)',
  'transform.cancel': 'キャンセル (Esc)',
  'transform.scale': '拡大率',
  'transform.angle': '角度',
  'crop.commit': '切り抜き (Enter)',
  'crop.cancel': 'キャンセル (Esc)',
  'shortcut.freeTransform': '自由変形',
  'shortcut.imageSize': '画像解像度',
  'shortcut.canvasSize': 'カンバスサイズ',
  'menu.file.exportPsd': 'PSD として書き出し...',
  'menu.edit.cut': 'カット',
  'menu.edit.copy': 'コピー',
  'menu.edit.paste': 'ペースト',
  'shortcut.copy': 'コピー',
  'shortcut.cut': 'カット',
  'shortcut.paste': 'ペースト (新規レイヤー)',
  'history.paste': 'ペースト',
  'layer.pasted': 'ペーストしたレイヤー',
  'toast.copied': 'コピーしました',
  'toast.copiedInternal': 'アプリ内にコピーしました (システムのクリップボードは利用できません)',
  'toast.psdWarnings': 'PSD 変換で {n} 件の情報が失われました ({kinds})',
  'adj.levels': 'レベル補正',
  'adj.curves': 'トーンカーブ',
  'adj.brightness-contrast': '明るさ・コントラスト',
  'adj.exposure': '露光量',
  'adj.hue-saturation': '色相・彩度',
  'adj.color-balance': 'カラーバランス',
  'adj.black-white': '白黒',
  'adj.photo-filter': 'レンズフィルター',
  'adj.channel-mixer': 'チャンネルミキサー',
  'adj.invert': '階調の反転',
  'adj.posterize': 'ポスタリゼーション',
  'adj.threshold': '2 階調化',
  'adj.gradient-map': 'グラデーションマップ',
  'adj.vibrance': '自然な彩度',
  'menu.layer.newAdjustment': '新規調整レイヤー',
  'menu.layer.newFillSolid': '新規塗りつぶしレイヤー (べた塗り)',
  'menu.layer.newFillGradient': '新規塗りつぶしレイヤー (グラデーション)',
  'history.addAdjustment': '調整レイヤーを追加',
  'history.adjust': '調整',
  'history.addFill': '塗りつぶしレイヤーを追加',
  'history.fillProps': '塗りつぶしの設定',
  'adj.reset': '初期化',
  'adj.channel': 'チャンネル',
  'adj.inputLevels': '入力レベル',
  'adj.outputLevels': '出力レベル',
  'adj.gamma': 'ガンマ',
  'adj.brightness': '明るさ',
  'adj.contrast': 'コントラスト',
  'adj.offset': 'オフセット',
  'adj.hue': '色相',
  'adj.saturation': '彩度',
  'adj.lightness': '明度',
  'adj.colorize': '色彩の統一',
  'adj.shadows': 'シャドウ',
  'adj.midtones': '中間調',
  'adj.highlights': 'ハイライト',
  'adj.preserveLum': '輝度を保持',
  'adj.reds': 'レッド系',
  'adj.yellows': 'イエロー系',
  'adj.greens': 'グリーン系',
  'adj.cyans': 'シアン系',
  'adj.blues': 'ブルー系',
  'adj.magentas': 'マゼンタ系',
  'adj.tint': '着色',
  'adj.filterColor': 'フィルターの色',
  'adj.density': '適用量',
  'adj.outputChannel': '出力チャンネル',
  'adj.constant': '平行調整',
  'adj.monochrome': 'モノクロ',
  'adj.levelsCount': '階調数',
  'adj.thresholdLevel': 'しきい値',
  'adj.reverse': '逆方向',
  'fill.color': '色',
  'fill.style': 'スタイル',
  'fill.angle': '角度',
  'fill.scale': '比率',
  'text.font': 'フォント',
  'text.size': 'サイズ',
  'text.bold': '太字',
  'text.italic': '斜体',
  'text.color': '色',
  'text.lineHeight': '行送り',
  'text.letterSpacing': '字間',
  'text.align': '揃え',
  'text.vertical': '縦書き',
  'text.fontMissing': 'このPCに無い',
  'text.loadFontFile': 'フォントファイルを読み込む (.ttf / .otf / .woff)。保存はされない',
  'text.fontFileLoaded': '{name} を読み込みました (このセッション限り)',
  'text.loadLocalFonts': 'ローカルフォントを読み込む',
  'text.placeholder': 'テキストを入力',
  'text.commit': '確定 (Esc / Cmd+Enter)',
  'text.rasterize': 'テキストをラスタライズ',
  'text.boxWidth': '段落幅',
  'history.addText': 'テキストを追加',
  'history.editText': 'テキストを編集',
  'history.rasterizeText': 'テキストをラスタライズ',
  'menu.layer.rasterizeText': 'テキストをラスタライズ',
  'fx.dropShadow': 'ドロップシャドウ',
  'fx.innerShadow': 'シャドウ (内側)',
  'fx.outerGlow': '光彩 (外側)',
  'fx.innerGlow': '光彩 (内側)',
  'fx.bevel': 'ベベルとエンボス',
  'fx.satin': 'サテン',
  'fx.colorOverlay': 'カラーオーバーレイ',
  'fx.gradientOverlay': 'グラデーションオーバーレイ',
  'fx.stroke': '境界線',
  'dialog.style.title': 'レイヤースタイル',
  'dialog.style.blend': '描画モード',
  'dialog.style.opacity': '不透明度',
  'dialog.style.angle': '角度',
  'dialog.style.distance': '距離',
  'dialog.style.spread': 'スプレッド',
  'dialog.style.choke': 'チョーク',
  'dialog.style.size': 'サイズ',
  'dialog.style.color': '色',
  'dialog.style.position': '位置',
  'dialog.style.outside': '外側',
  'dialog.style.inside': '内側',
  'dialog.style.center': '中央',
  'dialog.style.depth': '深さ',
  'dialog.style.soften': 'ソフト',
  'dialog.style.altitude': '高度',
  'dialog.style.highlight': 'ハイライト',
  'dialog.style.shadow': 'シャドウ',
  'dialog.style.invert': '反転',
  'dialog.style.source': 'ソース',
  'dialog.style.edge': 'エッジ',
  'dialog.style.centerSource': '中央',
  'dialog.style.styleKind': 'スタイル',
  'dialog.style.inner': 'ベベル (内側)',
  'dialog.style.outer': 'ベベル (外側)',
  'dialog.style.emboss': 'エンボス',
  'dialog.style.clear': 'すべて消去',
  'menu.layer.style': 'レイヤースタイル...',
  'history.layerStyle': 'レイヤースタイル',
  'layer.fx': 'fx',
  'shape.rect': '長方形',
  'shape.ellipse': '楕円',
  'shape.polygon': '多角形',
  'shape.line': 'ライン',
  'shape.radius': '角丸',
  'shape.sides': '辺の数',
  'shape.star': '星形',
  'shape.fill': '塗り',
  'shape.stroke': '線',
  'shape.strokeWidth': '線幅',
  'shape.strokeAlign': '線の位置',
  'shape.rasterize': 'シェイプをラスタライズ',
  'menu.select.fromLayer': 'レイヤーの不透明部分を選択',
  'history.addShape': 'シェイプを追加',
  'history.editShape': 'シェイプを編集',
  'history.rasterizeShape': 'シェイプをラスタライズ',
  'menu.layer.rasterizeShape': 'シェイプをラスタライズ',
  'filter.gaussianBlur': 'ぼかし (ガウス)...',
  'filter.boxBlur': 'ぼかし (ボックス)...',
  'filter.motionBlur': 'ぼかし (移動)...',
  'filter.surfaceBlur': 'ぼかし (表面)...',
  'filter.sharpen': 'シャープ...',
  'filter.unsharpMask': 'アンシャープマスク...',
  'filter.highPass': 'ハイパス...',
  'filter.addNoise': 'ノイズを加える...',
  'filter.pixelate': 'モザイク...',
  'filter.emboss': 'エンボス...',
  'filter.findEdges': '輪郭検出',
  'filter.invert': '階調の反転',
  'filter.desaturate': '彩度を下げる',
  'filter.vignette': 'ビネット...',
  'menu.filter': 'フィルター',
  'filter.cat.blur': 'ぼかし',
  'filter.cat.sharpen': 'シャープ',
  'filter.cat.noise': 'ノイズ',
  'filter.cat.pixelate': 'ピクセレート',
  'filter.cat.stylize': '表現手法',
  'filter.cat.other': 'その他',
  'filter.p.radius': '半径',
  'filter.p.amount': '量',
  'filter.p.angle': '角度',
  'filter.p.distance': '距離',
  'filter.p.threshold': 'しきい値',
  'filter.p.monochrome': 'グレースケール',
  'filter.p.cell': 'セルの大きさ',
  'filter.p.height': '高さ',
  'filter.p.softness': 'ソフトネス',
  'filter.preview': 'プレビュー',
  'filter.needRaster': 'フィルターはラスターレイヤーにだけ適用できます (テキスト / シェイプはラスタライズしてください)',
  'history.filter': 'フィルター: {name}',
  'menu.help.bridge': 'エージェント接続 (MCP)',
  'menu.help.bridgePort': 'MCP ブリッジのポート...',
  'bridge.connected': 'MCP 接続中',
  'bridge.connecting': 'MCP 接続待ち',
  'bridge.disconnected': 'MCP 未接続',
  'bridge.hint': 'ローカルの MCP ブリッジ (packages/mcp-server) を起動すると接続されます (ポート {port})',
  'tool.clone': 'コピースタンプツール',
  'tool.dodge': '覆い焼きツール',
  'tool.burn': '焼き込みツール',
  'tool.sponge': 'スポンジツール',
  'tool.blurTool': 'ぼかしツール',
  'tool.sharpenTool': 'シャープツール',
  'options.exposure': '露光量',
  'options.strength': '強さ',
  'options.aligned': '調整あり',
  'options.desaturate': '彩度を下げる',
  'options.saturate': '彩度を上げる',
  'clone.setSource': 'Alt+クリックでコピー元を設定してください',
  'history.clone': 'コピースタンプ',
  'history.dodge': '覆い焼き',
  'history.burn': '焼き込み',
  'history.sponge': 'スポンジ',
  'history.blurTool': 'ぼかし',
  'history.sharpenTool': 'シャープ',
  'panel.histogram': 'ヒストグラム / 情報',
  'histogram.lum': '輝度',
  'histogram.mean': '平均',
  'histogram.median': '中央値',
  'histogram.selection': '選択',
  'menu.view.rulers': '定規',
  'menu.view.guides': 'ガイドを表示',
  'menu.view.grid': 'グリッドを表示',
  'menu.view.snap': 'スナップ',
  'menu.view.clearGuides': 'ガイドを消去',
  'menu.view.gridSize': 'グリッド間隔...',
  'history.addGuide': 'ガイドを追加',
  'history.moveGuide': 'ガイドを移動',
  'history.removeGuide': 'ガイドを削除',
  'history.clearGuides': 'ガイドを消去',
  'shortcut.rulers': '定規',
  'shortcut.grid': 'グリッド',
  'shortcut.guides': 'ガイド',
  'shortcut.quickMask': 'クイックマスクモード',
  'menu.select.quickMask': 'クイックマスクモードで編集',
  'menu.select.saveChannel': '選択範囲を保存...',
  'menu.select.loadChannel': '選択範囲を読み込み',
  'history.quickMask': 'クイックマスク',
  'history.saveChannel': '選択範囲を保存',
  'history.loadChannel': '選択範囲を読み込み',
  'history.removeChannel': 'チャンネルを削除',
  'history.renameChannel': 'チャンネル名を変更',
  'panel.channels': 'チャンネル',
  'channels.empty': '保存した選択範囲はありません',
  'channels.load': '選択範囲として読み込み',
  'channels.delete': '削除',
  'export.estimated': '推定サイズ',
  'export.preview': 'プレビュー',
  'export.original': '元画像',
  'export.stripMeta': 'メタデータは含まれません (再エンコードのため)',
  'filter.median': 'メディアン...',
  'filter.despeckle': '輪郭以外をぼかす',
  'filter.dustScratches': 'ダスト & スクラッチ...',
  'filter.reduceNoise': 'ノイズを軽減...',
  'filter.oilPaint': '油彩...',
  'filter.p.strength': '強さ',
  'filter.p.preserveDetails': 'ディテールを保持',
  'filter.working': '処理中…',
  'align.left': '左端を揃える',
  'align.hcenter': '水平方向中央を揃える',
  'align.right': '右端を揃える',
  'align.top': '上端を揃える',
  'align.vcenter': '垂直方向中央を揃える',
  'align.bottom': '下端を揃える',
  'align.distributeH': '水平方向に分布',
  'align.distributeV': '垂直方向に分布',
  'menu.layer.align': '整列',
  'menu.layer.distribute': '分布',
  'history.alignLayers': 'レイヤーを整列',
  'history.distributeLayers': 'レイヤーを分布',
  'panel.actions': 'アクション',
  'actions.record': '記録開始',
  'actions.stop': '記録停止',
  'actions.play': '再生',
  'actions.delete': '削除',
  'actions.rename': '名前を変更',
  'actions.export': 'JSON として書き出し',
  'actions.import': 'JSON を読み込み',
  'actions.batch': '複数ファイルに一括適用...',
  'actions.empty': 'アクションはありません。● で記録を開始すると、メニューやダイアログの操作 (コマンド) が記録されます',
  'actions.recording': '記録中: {name} ({n})',
  'actions.newName': '新規アクション',
  'actions.played': 'アクション「{name}」を再生しました',
  'actions.failed': 'アクションの再生に失敗: {error}',
  'actions.imported': 'アクションを {n} 件読み込みました',
  'actions.batchDone': '{n} 件のファイルを処理しました',
  'actions.steps': '{n} ステップ',
  'tool.pen': 'ペンツール',
  'pen.hint': 'クリックでアンカー、ドラッグで曲線。始点をクリックで閉じる、Enter で確定、Esc で取り消し',
  'pen.commit': 'パスを確定',
  'pen.cancel': '取り消し',
  'history.editPath': 'パスを編集',
  'shortcuts.change': '変更',
  'shortcuts.press': 'キーを押してください… (Esc で中止)',
  'shortcuts.reset': '初期設定に戻す',
  'shortcuts.editHint': 'ショートカットをクリックすると変更できます。設定はこのブラウザに保存されます',
  'filter.liquify': 'ゆがみ...',
  'liquify.warp': '前方ワープ',
  'liquify.reconstruct': '再構築',
  'liquify.twirlCw': '渦 (時計回り)',
  'liquify.twirlCcw': '渦 (反時計回り)',
  'liquify.pucker': '縮小',
  'liquify.bloat': '膨張',
  'liquify.size': 'ブラシサイズ',
  'liquify.pressure': '筆圧',
  'liquify.mesh': 'メッシュを表示',
  'liquify.restoreAll': 'すべて復元',
  'liquify.proxy': 'プレビューは {pct}% に縮小して編集しています (確定時に全解像度で適用)',
  'liquify.frozen': '選択範囲の外は凍結されます',
  'liquify.empty': 'レイヤーに画素がありません',
  'history.liquify': 'ゆがみ',
  'tool.quickSelect': 'クイック選択ツール',
  'history.quickSelect': 'クイック選択',
  'history.colorRange': '色域指定',
  'history.refineEdge': '選択範囲を調整',
  'menu.select.colorRange': '色域指定...',
  'menu.select.refine': '選択範囲を調整...',
  'colorRange.title': '色域指定',
  'colorRange.fuzziness': '許容量',
  'colorRange.invert': '反転',
  'colorRange.pick': 'プレビューをクリックしてサンプル色を選ぶ',
  'colorRange.sampleAll': '全レイヤーを対象',
  'refine.title': '選択範囲を調整',
  'refine.smooth': '滑らかに',
  'refine.feather': 'ぼかし',
  'refine.contrast': 'コントラスト',
  'refine.shift': 'エッジをシフト',
  'menu.select.subject': '被写体を選択 (AI)...',
  'menu.layer.removeBackground': '背景を削除 (AI)...',
  'menu.help.ai': 'AI モデルの設定...',
  'history.aiSelect': '被写体を選択 (AI)',
  'history.aiRemoveBackground': '背景を削除 (AI)',
  'history.setMask': 'レイヤーマスクを設定',
  'ai.consent.title': 'AI モデルの取得について',
  'ai.consent.body': 'このアプリは通常、外部と一切通信しません。AI 機能 (被写体の選択 / 背景の削除) を使うには、推論ランタイムとモデルを一度だけ外部から取得する必要があります。取得したファイルはこのブラウザに保存され、画像や編集内容は外部に送信されません。',
  'ai.consent.what': '取得するもの',
  'ai.consent.from': '取得元',
  'ai.consent.size': 'サイズ',
  'ai.consent.license': 'ライセンス',
  'ai.consent.model': 'モデル',
  'ai.consent.note1': '取得は同意後、最初に AI 機能を使うときに行われます (進捗はステータスバーに表示)',
  'ai.consent.note2': '推論はすべてブラウザ内 (WebAssembly) で行われます。画像は送信されません',
  'ai.consent.note3': 'モデルのライセンスはそれぞれの配布元に従います。RMBG-1.4 は非商用のみです',
  'ai.consent.agree': '同意して有効にする',
  'ai.consent.revoke': '同意を取り消してキャッシュを削除',
  'ai.revoked': 'AI モデルの同意を取り消し、キャッシュを削除しました',
  'ai.selected': '被写体を選択しました',
  'ai.removed': '背景をレイヤーマスクとして削除しました (マスクは編集できます)',
  'ai.failed': 'AI 処理に失敗: {reason}',
  'ai.progress': 'AI: {label} {pct}%',
  'layer.smart': 'スマートオブジェクト',
  'menu.layer.convertToSmart': 'スマートオブジェクトに変換',
  'menu.layer.rasterizeSmart': 'スマートオブジェクトをラスタライズ',
  'history.convertToSmart': 'スマートオブジェクトに変換',
  'history.rasterizeSmart': 'スマートオブジェクトをラスタライズ',
  'history.editSmart': 'スマートオブジェクトを編集',
  'history.resetSmart': '変形をリセット',
  'history.replaceSmart': '内容を置き換え',
  'smart.source': '元画像',
  'smart.interpolation': '補間',
  'smart.reset': '変形をリセット',
  'smart.rasterize': 'ラスタライズ',
  'smart.replace': '内容を置き換え...',
  'smart.hint': '自由変形は元画像に対して非破壊で適用されます',
  'tool.heal': '修復ブラシツール',
  'tool.spotHeal': 'スポット修復ブラシツール',
  'history.heal': '修復ブラシ',
  'history.spotHeal': 'スポット修復',
  'history.contentAwareFill': 'コンテンツに応じた塗りつぶし',
  'menu.edit.contentAwareFill': 'コンテンツに応じた塗りつぶし',
  'options.lasso.magnetic': 'マグネット',
  'menu.help.resetWorkspace': 'ワークスペースをリセット',
  'workspace.resetConfirm': 'ツール設定・パネル幅・表示設定を初期値に戻して再読み込みします。よろしいですか?',
  'panel.navigator': 'ナビゲーター',
  'panel.swatches': 'スウォッチ',
  'swatches.add': '描画色を追加',
  'swatches.hint': 'クリックで描画色、Alt+クリックで背景色、右クリックで削除',
  'transform.mode.free': '自由変形',
  'transform.mode.distort': '自由な形に',
  'transform.mode.perspective': '遠近法',
  'text.warp': 'ワープ',
  'text.warp.none': 'なし',
  'text.warp.arc': '円弧',
  'text.warp.arcLower': '下弦',
  'text.warp.arcUpper': '上弦',
  'text.warp.bulge': '膨張',
  'text.warp.flag': '旗',
  'text.warp.wave': '波形',
  'text.warp.fisheye': '魚眼',
  'text.warp.rise': '上昇',
  'text.warp.bend': 'カーブ',
  'text.warp.h': '水平方向',
  'text.warp.v': '垂直方向',
  'menu.edit.defineBrush': 'ブラシを定義...',
  'brush.defined': 'ブラシ先端を定義しました (ブラシツールで選べます)',
  'options.tip': 'ブラシ先端',
  'options.tip.round': '丸',
  'options.angle': '角度',
  'options.roundness': '真円率',
  'options.scatter': '散布',
  'options.sizeJitter': 'サイズのジッター',
  'options.preset': 'プリセット',
  'options.preset.save': '現在の設定を保存...',
  'options.preset.delete': 'プリセットを削除...',
  'menu.edit.fill': '塗りつぶし...',
  'menu.edit.stroke': '境界線を描く...',
  'menu.image.rotateArbitrary': '任意の角度で回転...',
  'menu.image.trim': 'トリミング (透明部分)',
  'menu.image.autoTone': '自動トーン補正',
  'menu.image.autoContrast': '自動コントラスト',
  'menu.image.flatten': '画像を統合',
  'menu.layer.viaCopy': '選択範囲をコピーしたレイヤー',
  'menu.layer.viaCut': '選択範囲をカットしたレイヤー',
  'menu.layer.mergeDown': '下のレイヤーと結合',
  'menu.layer.mergeVisible': '表示レイヤーを結合',
  'shortcut.mergeDown': '下のレイヤーと結合',
  'shortcut.mergeVisible': '表示レイヤーを結合',
  'shortcut.viaCopy': '選択範囲をコピーしたレイヤー',
  'shortcut.viaCut': '選択範囲をカットしたレイヤー',
  'shortcut.fill': '塗りつぶし',
  'shortcut.autoTone': '自動トーン補正',
  'shortcut.autoContrast': '自動コントラスト',
  'history.merge': 'レイヤーを結合',
  'history.layerViaCopy': '選択範囲をコピーしたレイヤー',
  'history.layerViaCut': '選択範囲をカットしたレイヤー',
  'history.fill': '塗りつぶし',
  'history.stroke': '境界線を描く',
  'history.rotateArbitrary': 'カンバスを回転',
  'dialog.fill.title': '塗りつぶし',
  'dialog.fill.use': '使用',
  'dialog.fill.foreground': '描画色',
  'dialog.fill.background': '背景色',
  'dialog.fill.custom': 'カラー',
  'dialog.fill.opacity': '不透明度',
  'dialog.stroke.title': '境界線を描く',
  'dialog.stroke.width': '幅',
  'dialog.stroke.position': '位置',
  'dialog.stroke.inside': '内側',
  'dialog.stroke.center': '中央',
  'dialog.stroke.outside': '外側',
  'dialog.rotate.title': 'カンバスを回転',
  'dialog.rotate.angle': '角度 (時計回り)',
  'gradient.color': '色',
  'gradient.position': '位置',
  'gradient.opacity': '不透明度',
  'gradient.reverse': '反転',
  'gradient.remove': 'ストップを削除',
  'options.gradientCustom': 'カスタム',
  'history.snapshot': 'スナップショット',
  'history.restoreSnapshot': 'スナップショットを復元',
  'snapshot.take': 'スナップショットを作成',
  'snapshot.delete': '削除',
  'snapshot.name': 'スナップショット {n}',
  'menu.file.exportLayers': 'レイヤーを個別に書き出し (PNG ZIP)...',
  'toast.exportedLayers': '{n} 枚のレイヤーを書き出しました',
  'dialog.style.blendIf': 'ブレンド条件',
  'dialog.style.blendIfChannel': 'チャンネル',
  'dialog.style.gray': 'グレー',
  'dialog.style.thisLayer': 'このレイヤー',
  'dialog.style.underlying': '下になっているレイヤー',
  'dialog.style.blendIfHint': '[黒側 開始, 黒側 終了, 白側 開始, 白側 終了] (0..255)。開始と終了の間は滑らかに混ざります',
  'adj.selective-color': '特定色域の選択',
  'adj.sel.range': '色域',
  'adj.sel.reds': 'レッド系',
  'adj.sel.yellows': 'イエロー系',
  'adj.sel.greens': 'グリーン系',
  'adj.sel.cyans': 'シアン系',
  'adj.sel.blues': 'ブルー系',
  'adj.sel.magentas': 'マゼンタ系',
  'adj.sel.whites': '白色系',
  'adj.sel.neutrals': '中間色系',
  'adj.sel.blacks': '黒色系',
  'adj.relative': '相対値',
  'pattern.title': 'パターン',
  'pattern.none': 'パターンがありません (編集 → パターンを定義)',
  'pattern.defined': 'パターンを定義しました',
  'menu.edit.definePattern': 'パターンを定義...',
  'menu.layer.newFillPattern': '新規塗りつぶしレイヤー (パターン)',
  'fx.patternOverlay': 'パターンオーバーレイ',
  'history.definePattern': 'パターンを定義',
  'history.removePattern': 'パターンを削除',
  'adj.color-lookup': 'カラールックアップ',
  'adj.lut.current': 'LUT',
  'adj.lut.none': '(なし: 恒等)',
  'adj.lut.preset': 'プリセット',
  'adj.lut.load': '.cube を読み込み...',
  'adj.lut.identity': '恒等',
  'adj.lut.sepia': 'セピア',
  'adj.lut.warm': '暖色',
  'adj.lut.cool': '寒色',
  'adj.lut.crisp': 'くっきり',
  'adj.lut.faded': 'フェード',
  'adj.lut.mono': 'モノクロ',
  'menu.layer.strokePath': 'パスの境界線をブラシで描く',
  'menu.layer.fillPath': 'パスを塗りつぶし',
  'history.strokePath': 'パスの境界線を描く',
  'history.fillPath': 'パスを塗りつぶし',
  'transform.mode.warp': 'ワープ',
  'history.warp': 'ワープ',
  'panel.comps': 'レイヤーカンプ',
  'comps.add': '新規レイヤーカンプ',
  'comps.apply': '適用',
  'comps.update': '現在の状態で更新',
  'comps.delete': '削除',
  'comps.empty': 'レイヤーカンプはありません。＋ で現在の表示 / 位置 / スタイルを保存します',
  'history.addComp': 'レイヤーカンプを追加',
  'history.updateComp': 'レイヤーカンプを更新',
  'history.applyComp': 'レイヤーカンプを適用',
  'history.removeComp': 'レイヤーカンプを削除',
  'history.renameComp': 'レイヤーカンプ名を変更',
  'tool.smudge': '指先ツール',
  'history.smudge': '指先',
  'guide.open': 'ツールガイド (F1)',
  'guide.steps': '使い方',
  'guide.keys': 'キー操作',
  'guide.tip': 'コツ',
  'guide.close': '閉じる',
  'guide.switchHint': 'ツールを切り替えると内容も変わります',
  'guide.allShortcuts': 'ショートカット一覧',
  'guide.hintSuffix': '(F1 で詳しい使い方)',
  'guide.hintsReset': 'ツールの初回ヒントをリセットしました',
  'menu.help.toolGuide': 'ツールガイド',
  'menu.help.resetHints': 'ツールの初回ヒントを再表示',
  'shortcut.toolGuide': 'ツールガイドの表示 / 非表示',
  'mobile.title': 'スマートフォンには対応していません',
  'mobile.body': 'このアプリは PC のブラウザ向けです。スマートフォンでは正しく操作できないため、お手数ですが PC で開いてください。',
  'mobile.r1': 'マウスやペンでの細かい操作と、キーボードのショートカットを前提にしています',
  'mobile.r2': 'ツールバー・オプションバー・パネルを同時に表示するため、横幅が必要です',
  'mobile.r3': '画像の合成に PC の GPU とメモリを使います',
  'mobile.copy': 'リンクをコピー',
  'mobile.copied': 'コピーしました',
  'mobile.continue': 'それでも開く (動作は保証されません)',
  'mobile.repo': 'GitHub で見る',
  'start.guide': 'ツールの使い方を見る (F1)',
  'tool.crop': '切り抜きツール',
  'tool.eyedropper': 'スポイトツール',
  'tool.brush': 'ブラシツール',
  'tool.eraser': '消しゴムツール',
  'tool.fill': '塗りつぶしツール',
  'tool.gradient': 'グラデーションツール',
  'tool.text': '横書き文字ツール',
  'tool.shape': '長方形ツール',
  'tool.comingSoon': '(今後のフェーズで実装)',
  'panel.layers': 'レイヤー',
  'panel.properties': 'プロパティ',
  'panel.history': 'ヒストリー',
  'layer.opacity': '不透明度',
  'layer.fill': '塗り',
  'layer.blendMode': '描画モード',
  'layer.name': '名前',
  'layer.visible': '表示/非表示',
  'layer.background': '背景',
  'layer.new': '新規レイヤー',
  'layer.delete': '削除',
  'layer.empty': 'レイヤーがありません',
  'layer.lockedHint': 'ロック中',
  'start.title': 'ブラウザで動く画像編集',
  'start.subtitle': '画像はこの端末の外へ送信されません。保存は手動 (ZIP / 画像書き出し) です。',
  'start.new': '新規作成',
  'start.open': '画像 / プロジェクトを開く',
  'start.drop': 'ここに画像や .bpe.zip をドロップ',
  'dialog.new.title': '新規ドキュメント',
  'dialog.new.name': '名前',
  'dialog.new.width': '幅',
  'dialog.new.height': '高さ',
  'dialog.new.dpi': '解像度 (dpi)',
  'dialog.new.background': 'カンバスカラー',
  'dialog.new.bg.transparent': '透明',
  'dialog.new.bg.white': '白',
  'dialog.new.bg.black': '黒',
  'dialog.new.create': '作成',
  'dialog.new.preset': 'プリセット',
  'dialog.export.title': '画像を書き出し',
  'dialog.export.format': '形式',
  'dialog.export.quality': '画質',
  'dialog.export.scale': '倍率',
  'dialog.export.size': '出力サイズ',
  'dialog.export.run': '書き出し',
  'dialog.export.transparentHint': 'JPEG は透明部分が白になります',
  'dialog.cancel': 'キャンセル',
  'dialog.ok': 'OK',
  'dialog.close.confirm': '未保存の変更があります。閉じてもよいですか?',
  'unsaved.badge': '未保存',
  'unsaved.beforeUnload': '未保存の変更があります。',
  'toast.opened': '{name} を開きました',
  'toast.saved': 'プロジェクトを保存しました',
  'toast.savedWithFonts': '保存しました (フォント {n} 件を同梱)',
  'toast.fontsMissing': 'この PC に無い書体が使われています: {fonts} — 別の書体で表示されています',
  'toast.exported': '{name} を書き出しました',
  'toast.openFailed': '開けませんでした: {reason}',
  'toast.saveFailed': '保存できませんでした: {reason}',
  'toast.unsupportedFile': '対応していないファイル形式です: {name}',
  'toast.tooLarge': '画像が大きすぎます (最大 {max}px): {w}×{h}',
  'toast.webglLost': 'GPU コンテキストが失われました。復旧中...',
  'toast.webglRestored': 'GPU コンテキストを復旧しました',
  'toast.undo': '取り消し: {label}',
  'toast.redo': 'やり直し: {label}',
  'history.addLayer': 'レイヤーを追加',
  'history.deleteLayer': 'レイヤーを削除',
  'history.duplicateLayer': 'レイヤーを複製',
  'history.renameLayer': 'レイヤー名を変更',
  'history.layerProps': 'レイヤー設定',
  'history.toggleVisible': '表示切替',
  'history.moveLayer': 'レイヤーを移動',
  'history.reorderLayer': 'レイヤー順序',
  'history.openImage': '画像を開く',
  'history.placeImage': '画像を配置',
  'history.groupLayers': 'グループ化',
  'history.ungroupLayers': 'グループ解除',
  'history.clipLayer': 'クリッピングマスク',
  'history.addMask': 'レイヤーマスクを追加',
  'history.removeMask': 'レイヤーマスクを削除',
  'history.toggleMask': 'マスクの有効/無効',
  'menu.layer.group': 'レイヤーをグループ化',
  'menu.layer.ungroup': 'グループ解除',
  'menu.layer.clip': 'クリッピングマスクを作成/解除',
  'menu.layer.addMaskReveal': 'レイヤーマスクを追加 (すべて表示)',
  'menu.layer.addMaskHide': 'レイヤーマスクを追加 (すべて隠す)',
  'menu.layer.removeMask': 'レイヤーマスクを削除',
  'menu.layer.toggleMask': 'レイヤーマスクを有効/無効',
  'layer.mask': 'マスク',
  'layer.clipped': '下のレイヤーでクリップ',
  'layer.group': 'グループ',
  'shortcut.group': 'レイヤーをグループ化',
  'menu.select': '選択範囲',
  'menu.select.all': 'すべてを選択',
  'menu.select.deselect': '選択を解除',
  'menu.select.invert': '選択範囲を反転',
  'menu.select.feather': '境界をぼかす...',
  'menu.select.expand': '拡張...',
  'menu.select.contract': '縮小...',
  'menu.select.border': '境界線...',
  'menu.edit.clear': '消去',
  'shortcut.selectAll': 'すべてを選択',
  'shortcut.deselect': '選択を解除',
  'shortcut.invert': '選択範囲を反転',
  'shortcut.clear': '選択範囲を消去 / レイヤーを削除',
  'history.select': '選択範囲',
  'history.selectAll': 'すべてを選択',
  'history.deselect': '選択を解除',
  'history.invertSelection': '選択範囲を反転',
  'history.featherSelection': '境界をぼかす',
  'history.expandSelection': '選択範囲を拡張',
  'history.contractSelection': '選択範囲を縮小',
  'history.borderSelection': '境界線',
  'history.clearPixels': '消去',
  'options.mode.new': '新規',
  'options.mode.add': '追加',
  'options.mode.subtract': '削除',
  'options.mode.intersect': '交差',
  'options.shape.rect': '長方形',
  'options.shape.ellipse': '楕円',
  'options.lasso.free': 'なげなわ',
  'options.lasso.polygon': '多角形',
  'options.feather': 'ぼかし',
  'options.antialias': 'アンチエイリアス',
  'options.tolerance': '許容値',
  'options.contiguous': '隣接',
  'options.sampleAll': '全レイヤーを対象',
  'dialog.modify.amount': '量 (px)',
  'dialog.modify.feather': '境界をぼかす',
  'dialog.modify.expand': '選択範囲を拡張',
  'dialog.modify.contract': '選択範囲を縮小',
  'dialog.modify.border': '境界線を選択',
  'shortcut.clip': 'クリッピングマスク',
  'unsupported.title': 'このブラウザでは動作しません',
  'unsupported.body': 'このアプリは WebGL2 を使って画像を合成します。お使いのブラウザまたは GPU 設定では WebGL2 が利用できません。最新の Chrome / Edge / Firefox / Safari で開くか、ブラウザのハードウェアアクセラレーションを有効にしてください。',
  'status.zoom': 'ズーム',
  'status.size': 'サイズ',
  'status.memory': 'メモリ',
  'status.noDocument': 'ドキュメントなし',
  'fontEmbed.title': 'フォントの再配布にご注意ください',
  'fontEmbed.body': '保存したプロジェクトには、次の書体のファイルがそのまま入っています (サブセット化していません)。フォント自身が同梱を許可していません。',
  'fontEmbed.restricted': '埋め込み・受け渡しが禁止されています (fsType: restricted)',
  'fontEmbed.previewPrint': '表示と印刷のみ許可されています。編集できる形での同梱は範囲外です (fsType: preview & print)',
  'fontEmbed.note': '自分の環境で開く分には問題ありません。このプロジェクトファイルを他の人に渡さないでください。書き出した画像 (PNG / JPEG など) の配布には制限はありません。',
  'about.body': '完全にブラウザ内で動作する Photoshop ライクな画像編集アプリ。バージョン {version}',
  'about.fonts': '同梱フォント (SIL Open Font License 1.1):',
  'shortcut.undo': '取り消し',
  'shortcut.redo': 'やり直し',
  'shortcut.zoomIn': 'ズームイン',
  'shortcut.zoomOut': 'ズームアウト',
  'shortcut.fit': '画面サイズに合わせる',
  'shortcut.actual': '100% 表示',
  'shortcut.hand': '手のひら (押している間)',
  'shortcut.new': '新規ドキュメント',
  'shortcut.open': '開く',
  'shortcut.save': 'プロジェクトを保存',
  'shortcut.export': '画像を書き出し',
  'shortcut.newLayer': '新規レイヤー',
  'shortcut.deleteLayer': 'レイヤーを削除',
  'shortcut.tool': 'ツール切替',
  'shortcut.polygonClose': '多角形選択を確定 / 取り消し',
  'shortcut.brushSize': 'ブラシサイズ',
  'shortcut.swapColors': '描画色と背景色を入れ替え',
  'shortcut.resetColors': '描画色と背景色を初期化',
  'history.brush': 'ブラシ',
  'history.pencil': '鉛筆',
  'history.eraser': '消しゴム',
  'options.size': 'サイズ',
  'options.hardness': '硬さ',
  'options.opacity': '不透明度',
  'options.flow': '流量',
  'options.spacing': '間隔',
  'options.smoothing': '滑らかさ',
  'options.pencil': '鉛筆モード',
  'options.pressureSize': '筆圧でサイズ',
  'options.pressureFlow': '筆圧で流量',
  'color.foreground': '描画色',
  'color.background': '背景色',
  'color.swap': '入れ替え (X)',
  'color.reset': '初期化 (D)',
  'color.hex': 'HEX',
  'tool.pencil': '鉛筆ツール',
  'brush.needRasterLayer': 'ラスターレイヤーを選択してください',
  'options.gradient.linear': '線形',
  'options.gradient.radial': '円形',
  'options.gradient.angle': '円錐形',
  'options.gradient.reflected': '反射形',
  'options.gradient.diamond': '菱形',
  'options.reverse': '逆方向',
  'options.dither': 'ディザ',
  'options.toTransparent': '描画色→透明',
  'history.gradient': 'グラデーション',
  'brush.locked': 'レイヤーがロックされています'
} as const

export type I18nKey = keyof typeof ja
